import { LayoutConfig } from 'haba-storefrontlib';

export const habaLayoutConfig: LayoutConfig = {
  // need to be in sync with grid.scss
  // Spartacus always wants to know when the breakpoint ends.
  // The Bootstrap Css wants to know when the breakpoint starts.
  // That is why we need to put the value of the sm from the grid.scss to the xs on the customLayoutConfig.
  breakpoints: {
    xs: 576,
    md: 768,
    lg: 1024,
    xl: 1540,
  },
  layoutSlots: {
    ProductDetailsPageTemplate: {
      slots: [
        'TopProductDetailsPage',
        'Images',
        'Summary',
        'UpSelling',
        'CrossSelling',
        'PlaceholderContentSlot',
      ],
    },
    MyAccountLoginDataPageTemplate: {
      slots: ['SideContent', 'LeftContent', 'RightContent'],
    },
    AccountPageTemplate: {
      slots: ['SideContent', 'BodyContent'],
    },
    CheckoutLoginPageTemplate: {
      // CenterContentSlot only removed from FE: TODO: adjust it on the backoffice as well
      // slots: ['TopContent', 'LeftContentSlot', 'CenterContentSlot', 'RightContentSlot', 'BottomContent'],
      slots: ['TopContent', 'LeftContentSlot', 'RightContentSlot', 'BottomContent'],
    },
    AuthorizePageTemplate: {
      slots: ['Header', 'Content'],
    },
    CatalogTemplate: {
      slots: ['CatalogContentSlot', 'CatalogFormSlot'],
    },
    ContentPage1Template: {
      slots: ['MiddleContent'],
    },
    ParcellabPageTemplate: {
      slots: ['Content'],
    },
    LoginPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot', 'BottomContent'],
    },
    CartPageTemplate: {
      slots: ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent', 'BottomContent'],
    },
    OrderConfirmationPageTemplate: {
      slots: ['BodyContent', 'BottomContent'],
    },
  },
};
